<div>
  <div class="filters-title">
    <p>Filters</p>
    <div (click)="closeFilters()">
      <img src="assets/close-modal-icon.svg">
    </div>
  </div>
  <div class="filter-by-container">
    <div class="filter-by-title">
      Meals Categories
      <div class="clear-all" (click)="onClearCategoriesClicked()">
        Clear
      </div>
    </div>
    <div class="filter-by-item" *ngFor="let category of merchantFilters?.categories; let i = index">
      <input type="checkbox" id="{{category.id}}" name="{{category.id}}" value="All"
             [(ngModel)]="categoriesCheckBoxes[i]"
             (change)="filterResults()">
      <label for="{{category.id}}">{{ category.name }}</label><br>
    </div>
    <div class="horizontal-separator"></div>
    <div class="filter-by-title">
      Ordering Options
    </div>
    <div class="filter-by-item" *ngIf="merchantFilters !== undefined && merchantFilters !== null">
      <input type="checkbox" id="{{merchantFilters.deliveryAvailable.name}}"
             [(ngModel)]="deliveryAvailableCheckBox"
             (change)="filterResults()"
             name="{{merchantFilters.deliveryAvailable.name}}"
             value="{{merchantFilters.deliveryAvailable.name}}">
      <label
        for="{{merchantFilters.deliveryAvailable.name}}">{{ merchantFilters.deliveryAvailable.name }}</label><br>
    </div>
    <div class="filter-by-item" *ngIf="merchantFilters !== undefined && merchantFilters !== null">
      <input type="checkbox" id="{{merchantFilters.pickupAvailable.name}}"
             [(ngModel)]="pickUpAvailableCheckBox"
             (change)="filterResults()"
             name="{{merchantFilters.pickupAvailable.name}}" value="{{merchantFilters.pickupAvailable.name}}">
      <label for="{{merchantFilters.pickupAvailable.name}}">{{ merchantFilters.pickupAvailable.name }}</label><br>
    </div>
    <div class="horizontal-separator"></div>
    <div class="filter-by-price-container">
      <div class="filter-by-title">
        Price range (EGP)
      </div>
      <div *ngIf="merchantFilters !== undefined && merchantFilters !== null">
        <mat-slider min="{{merchantFilters.price.min}}" max="{{merchantFilters.price.max}}" step="1" discrete
                    [displayWith]="format">
          <input matSliderStartThumb [(ngModel)]="minPrice" (change)="filterResults()" id="min">
          <input matSliderEndThumb [(ngModel)]="maxPrice" (change)="filterResults()" id="max">
        </mat-slider>
      </div>
      <div class="horizontal-separator"></div>
    </div>
    <div class="filter-by-title">
      Ready within
      <div class="clear-all" (click)="onClearReadyWithinClicked()">
        Clear
      </div>
    </div>
    <div class="filter-by-item" *ngFor="let readyWithin of merchantFilters.readyWithin.values; let i = index">
      <input type="checkbox" id="{{readyWithin.id}}" name="{{readyWithin.id}}" value="All"
             [(ngModel)]="readyWithinCheckBoxes[i]"
             (change)="filterResults()">
      <label for="{{readyWithin.id}}">{{ readyWithin.name }}</label><br>
    </div>
    <div class="horizontal-separator"></div>
    <div class="filter-by-title">
      Meal Status
      <div class="clear-all" (click)="onClearCookStateClicked()">
        Clear
      </div>
    </div>
    <div class="filter-by-item" *ngFor="let mealStatus of merchantFilters.state.values; let i = index;">
      <input type="checkbox" id="{{mealStatus.id}}" name="{{mealStatus.id}}" value="{{mealStatus.id}}"
             [(ngModel)]="mealStateCheckBoxes[i]"
             (change)="filterResults()">
      <label for="{{mealStatus.id}}">{{ mealStatus.name }}</label><br>
    </div>
    <div class="horizontal-separator"></div>
    <div class="filter-by-title">
      Delivery Areas
      <div class="clear-all" (click)="onClearDeliveryAreasClicked()">
        Clear
      </div>
    </div>
    <div class="filter-by-item" *ngFor="let deliveryArea of merchantFilters?.deliveryAreas; let i = index;">
      <input type="checkbox" id="{{deliveryArea.id}}" name="{{deliveryArea.id}}" value="{{deliveryArea.id}}"
             [(ngModel)]="deliveryAreasCheckBoxes[i]"
             (change)="filterResults()">
      <label for="{{deliveryArea.id}}">{{ deliveryArea.name }}</label><br>
    </div>
    <div class="horizontal-separator"></div>
    <div class="filter-by-title">
      Cities
      <div class="clear-all" (click)="onClearCitiesClicked()">
        Clear
      </div>
    </div>
    <div class="filter-by-item" *ngFor="let city of merchantFilters?.cities; let i = index;">
      <input type="checkbox" id="{{city.id}}" name="{{city.id}}" value="{{city.id}}"
             [(ngModel)]="citiesCheckBoxes[i]"
             (change)="filterResults()">
      <label for="{{city.id}}">{{ city.name }}</label><br>
    </div>
  </div>
  <div class="apply-filter-buttons">
    <primary-button title="Apply Filter" (onClick)="applyFilters()"></primary-button>
    <div class="clear-button" (click)="clearFilters()">
      <p>Clear Filter</p>
    </div>
  </div>
</div>
